import { MuiTelInput } from 'mui-tel-input';
import { forwardRef } from 'react';

// eslint-disable-next-line react/display-name
export default forwardRef((props, ref) => (
  <MuiTelInput
    variant="standard"
    {...props}
    inputProps={{ maxLength: props.value?.startsWith('+55') ? 13 : 15 }}
    preferredCountries={['BR']}
    langOfCountryName="pt-BR"
    forceCallingCode
    defaultCountry="BR"
    inputRef={ref}
  />
));
